export var createMuiTableContainerOverrides = function (_a) {
    var spacing = _a.spacing;
    return ({
        root: {
            '[class*="MuiPaper-root"] > &': {
                padding: spacing(0, 4, 4),
            },
        },
    });
};
//# sourceMappingURL=MuiTableContainer.js.map